module.exports = __webpack_public_path__ + "img/gx.503200d4.jpg";